var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrgIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18.3567343px",
    height: "18.3567343px",
    viewBox: "0 0 18.3567343 18.3567343",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0CCD3526-840F-4CDE-B44B-6BEA034C0AB2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Prospecting",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Relationship-Dashboard",
    transform: "translate(-1025.9247, -92.6557)",
    fill: "#585858",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "org-icon",
    transform: "translate(1025.9247, 92.6557)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.41498564,1.99701191 C5.41498564,0.895858826 4.51912681,0 3.41797373,0 C0.768652394,0.10971017 0.769405307,3.88474389 3.41797373,3.99402382 C4.51916266,3.99402382 5.41498564,3.098165 5.41498564,1.99701191 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.8359833,8.02630279 L6.8359833,7.4120334 C6.64768337,2.87645006 0.186614847,2.87996366 0,7.41199755 L0,8.02626694 C0,8.32327316 0.240788725,8.56406189 0.537794949,8.56406189 L6.29818836,8.56406189 C6.59519458,8.56406189 6.8359833,8.32330902 6.8359833,8.02630279 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9357724,1.99701191 C16.9357724,0.895858826 16.0399136,0 14.9387605,0 C12.2894392,0.10971017 12.2901921,3.88474389 14.9387605,3.99402382 C16.0399136,3.99402382 16.9357724,3.098165 16.9357724,1.99701191 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9387605,3.99402382 C13.0540761,3.99402382 11.5207868,5.52734893 11.5207868,7.41199755 L11.5207868,8.02626694 C11.5207868,8.32327316 11.7615755,8.56406189 12.0585818,8.56406189 L17.8189393,8.56406189 C18.1159455,8.56406189 18.3567343,8.32327316 18.3567343,8.02626694 L18.3567343,7.41199755 C18.3567343,5.52734893 16.823445,3.99402382 14.9387605,3.99402382 L14.9387605,3.99402382 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.37975443,9.75441723 C3.37975443,9.71605452 3.38047149,9.67787108 3.38118855,9.63968764 L2.30559865,9.63968764 C2.26279017,11.9450353 3.38032808,14.0278076 5.11088052,15.2961432 C5.26547864,14.9679449 5.45865459,14.6614376 5.68452847,14.382322 C4.28454065,13.3237623 3.37975443,11.6448382 3.37975443,9.75441723 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.80504217,4.46229981 C8.23543332,3.79242242 10.1213009,3.79242242 11.5516921,4.46229981 C11.8067503,4.16977521 12.0989522,3.91048634 12.420948,3.69185477 C10.5173331,2.61988602 7.83943697,2.61992187 5.93582212,3.69185477 C6.25778203,3.91048634 6.54998395,4.16981106 6.80504217,4.46229981 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9755457,9.63968764 C15.0173145,11.5610139 14.1007326,13.306266 12.6722058,14.382322 C12.8980797,14.6614018 13.0912198,14.9679449 13.2458537,15.2961432 C14.9763345,14.0279152 16.0939799,11.9449636 16.0511356,9.63968764 L14.9755457,9.63968764 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.175379,11.7896484 C11.175379,10.6884953 10.2795202,9.79263652 9.17836713,9.79263652 C6.5290458,9.90234669 6.52979871,13.6773804 9.17836713,13.7866603 C10.2795202,13.7866603 11.175379,12.8908374 11.175379,11.7896484 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.17836713,13.7866603 C7.29368266,13.7866603 5.76039341,15.3199855 5.76039341,17.2046341 L5.76039341,17.8189393 C5.76039341,18.1159455 6.00118213,18.3567343 6.29818836,18.3567343 L12.0585818,18.3567343 C12.355588,18.3567343 12.5963767,18.1159455 12.5963767,17.8189393 L12.5963767,17.2046699 C12.5963767,15.3199855 11.0630516,13.7866603 9.17836713,13.7866603 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrgIcon);
export default __webpack_public_path__ + "static/media/orgIcon.11820532b7b84e0b1f416a79d19333dc.svg";
export { ForwardRef as ReactComponent };